import { RCCreateFileRequestInputs } from '../../../components/robot-cloud/file-transfer/RCCreateFileRequest';


/**
 * The interface used for storing input errors from the Create File Request form
 */
export interface FileRequestInputErrors {
    fileType?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    uploadFile?: string | undefined;
}



/**
 * Validate all the user inputs for DOWNLOAD file request and return an Object that contain error message for the fields
 * that contain invalid input values. For DOWNLOAD requests, we need fileType, start/end date
 * @param inputs
 * @returns
 */
export const validateCreateDownloadFileRequestInputs = (inputs: RCCreateFileRequestInputs) => {
    const inputErrors: FileRequestInputErrors = {};

    if (!inputs.fileType) {
        inputErrors.fileType = 'error.input.generic.empty';
    }

    if (inputs.startDate === undefined) {
        inputErrors.startDate = 'file_transfer.input.error.date_range.empty';
    } else if (typeof inputs.startDate !== 'number' || inputs.startDate <= 0) {
        inputErrors.startDate = 'file_transfer.input.error.start_date.invalid';
    }

    if (inputs.endDate === undefined) {
        inputErrors.endDate = 'file_transfer.input.error.date_range.empty';
    } else if (typeof inputs.endDate !== 'number' || inputs.endDate <= 0) {
        inputErrors.endDate = 'file_transfer.input.error.end_date.invalid';
    }

    // If startDate is AFTER than endDate then show error for both start and end date inputs
    if (inputs.startDate !== undefined && inputs.endDate !== undefined && inputs.startDate >= inputs.endDate) {
        inputErrors.startDate = 'file_transfer.input.error.date_range.invalid';
        inputErrors.endDate = 'file_transfer.input.error.date_range.invalid';
    }

    return inputErrors;
};



/**
 * Validate all the user inputs for UPLOAD file request and return an Object that contain error message for the fields
 * that contain invalid input values. For UPLOAD requests, we only need 'uploadFile'
 * @param inputs
 * @returns
 */
export const validateCreateUploadFileRequestInputs = (inputs: RCCreateFileRequestInputs, maxUploadFileSize: number) => {
    const inputErrors: FileRequestInputErrors = {};

    if (!inputs.uploadFile) {
        inputErrors.uploadFile = 'error.input.generic.empty';
    } else if (inputs.uploadFile.size > maxUploadFileSize) {
        inputErrors.uploadFile = 'file_transfer.input.error.file.limit';
    }

    return inputErrors;
};
